/*
 * Copyright © 2018-2024, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React from "react";
import { Flowbite, Navbar } from "flowbite-react";
import { useLocalStorage } from "@uidotdev/usehooks";
import { simpleLightText } from "../../../../assets/AssetConfig";
import { Environments } from "../../../../models/Environments";
import EnvironmentBadge from "../../EnvironmentBadge";
import { PetOwnerMenuItem } from "../../MenuItem/MenuItemTypes";
import UserMenu from "../../UserMenu/UserMenu";
import { customTheme } from "../../Themes/NavTheme";
import PetOwnerNavItem from "./PetOwnerNavItem";
import PetOwnerMenuItems from "../../MenuItem/PetOwnerMenuItems";

interface Props {
  environment: Environments;
  activeMenu?: PetOwnerMenuItem;
}

const NavPetOwner: React.FC<Props> = ({ environment, activeMenu }: Props) => {
  const [darkMode] = useLocalStorage<boolean | undefined>("darkMode");

  return (
    <>
      <Flowbite theme={{ theme: customTheme, dark: darkMode }}>
        <Navbar id="owner-navbar" fluid>
          <Navbar.Brand href="/">
            <img alt="GlobalVet" width="142px" src={simpleLightText} />
            <EnvironmentBadge
              className="ml-5 no-underline hover:no-underline"
              environment={environment}
            />
          </Navbar.Brand>
          <UserMenu />
        </Navbar>
      </Flowbite>
      <nav
        className="fixed z-20 top-14 left-0 shadow w-full h-14 px-4 lg:px-6 hidden xl:flex items-center bg-white dark:bg-gray-800 dark:border-b dark:border-gray-700"
        id="owner-second-navbar"
      >
        <div className="container flex flex-wrap items-center justify-between xl:justify-start mx-auto px-0">
          <div className="flex items-center justify-between hidden w-full xl:flex xl:w-auto xl:order-1">
            <ul className="flex flex-row space-x-8 font-medium">
              {PetOwnerMenuItems.map((item, index) => (
                <li key={index}>
                  <PetOwnerNavItem
                    menu={item.type}
                    activeMenu={activeMenu}
                    href={item.href}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavPetOwner;
